// extracted by mini-css-extract-plugin
module.exports = {"bubble":"_1i81xl9qdH9b4QSqGAYHiP","right":"_1erdduWypwF5DXVdSXRRbu","left":"_2fJZDw1THscR10kt295WGP"};